export default [
	{
		slug: "poison",
		fr: {
			name: "Poison",
			description: "Inflige 1 point de dégât après chaque déplacement."
		},
		en: {
			name: "Poison",
			description: "Inflicts 1 damage after each move."
		}
	},
	{
		slug: "strength",
		fr: {
			name: "Force",
			description: "Confère +1 d'attaque."
		},
		en: {
			name: "Strength",
			description: "Gives +1 attack."
		}
	},
	{
		slug: "weakness",
		fr: {
			name: "Faiblesse",
			description: "Confère -1 d'attaque. L'attaque ne peut pas être inférieure à 1."
		},
		en: {
			name: "Weakness",
			description: "Gives -1 attack. Attack cannot be less than 1."
		}
	}
]